import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/groups',
    component: () => import('./views/PageGroupList'),
    children: [
      {
        path: 'pages',
        name: 'groups.pages',
        component: () => import('./views/PageGroupList'),
        meta: {
          auth: true
        }
      }
    ]
  },
  {
    path: '/groups/pages/new',
    name: 'groups.pages.new',
    component: () => import('./views/PageGroupCreate'),
    meta: {
      auth: true
    }
  },
  {
    path: '/groups/pages/:id',
    name: 'groups.pages.edit',
    component: () => import('./views/PageGroupCreate'),
    meta: {
      auth: true
    }
  }
])
